import React from 'react';
import { Icon } from './Icon.js';
export const IconLabel3 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3 5L3 19L15.5 19L22.5 12L15.5 5L3 5Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconLabel3.js.map